/* This is the EMIS Student for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + curacc + ' (បន្ត)'"></span>
    </div>
    <!-- G10, SI + SV -->
    <div>
      <table style="height: 87px; width: 850px" border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">អាយុ<p>(ឆ្នាំ)</p></td>            
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១០</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១០ (វិជ្ជាជីវៈ)</td>
            <td class="row-header-title" colspan="4">សរុបថ្នាក់ទី ១០</td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr v-for="(value, row) in ageHig.length - 1" :key="row">
            <!-- Draw only 8 columns -->
            <td class="col-title">{{ ageHig[row] }}</td>
            <td
              v-for="(value, col) in data[row].dt.length - 24"
              :key="col"
              :class="[!uppOnOff[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!uppOnOff[row][col]"
                class="number"
              />
            </td>
            <td v-for="col in 4" :key="'g1-' + col" class="row-data">
              <strong>{{ cols[row].group1[col - 1] }}</strong>
            </td>
          </tr>
          <!-- Total each column -->
          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 8" :key="col" class="row-data">
              <strong>{{ totalRows[0][col] | blank }}</strong>
            </td>
            <td v-for="col in 4" :key="'g1-' + col" class="row-data">
              <strong>{{ cols[ageHig.length - 1].group1[col - 1] }}</strong>
            </td>          
          </tr>
        </tbody>
      </table>
    </div>
    <div><br /></div>

    <!-- G11, SI + SO + SV -->
    <div>
      <table
        style="height: 87px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">អាយុ<p>(ឆ្នាំ)</p></td>            
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១១ (វិទ្យាសាស្រ្ត)</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១១ (វិទ្យាសាស្រ្តសង្គម)</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១១ (វិជ្ជាជីវៈ)</td>
            <td class="row-header-title" colspan="4">សរុបថ្នាក់ទី ១១</td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr v-for="(value, row) in ageHig.length - 1" :key="row">
            <!-- Draw only 12 columns -->
            <td class="col-title">{{ ageHig[row] }}</td>
            <td
              v-for="(value, col) in 12"
              :key="col"
              :class="[!uppOnOff[row][col + 8] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput v-model="data[row].dt[col + 8]" :disabled="!uppOnOff[row][col + 8]" class="number"/>
            </td>
            <!-- Total each column -->
            <td v-for="col in 4" :key="'g2-' + col" class="row-data">
              <strong>{{ cols[row].group2[col - 1] }}</strong>
            </td>
          </tr>

          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 12" :key="col" class="row-data">
              <strong>{{ totalRows[1][col] | blank }}</strong>
            </td>
            <td v-for="col in 4" :key="'g2-' + col" class="row-data">
              <strong>{{ cols[ageHig.length - 1].group2[col - 1] }}</strong>
            </td>       
          </tr>
        </tbody>
      </table>
    </div>
    <div><br /></div>

    <!-- G12, SI + SO + Total -->
    <div>
      <table
        style="height: 87px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">អាយុ<p>(ឆ្នាំ)</p></td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១២ (វិទ្យាសាស្រ្ត)</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១២ (វិទ្យាសាស្រ្តសង្គម)</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១២ (វិជ្ជាជីវៈ)</td>
            <td class="row-header-title" colspan="4">សរុបថ្នាក់ទី ១២</td>            
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr v-for="(value, row) in ageHig.length - 1" :key="row">
            <!-- Draw only 16 columns -->
            <td class="col-title">{{ ageHig[row] }}</td>
            <td
              v-for="(value, col) in 12"
              :key="col"
              :class="[!uppOnOff[row][col + 20] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col + 20]"
                :disabled="!uppOnOff[row][col + 20]"
                class="number"
              />
            </td>
            <!-- total in each row -->
            <td v-for="col in 4" :key="'g3-' + col" class="row-data">
              <strong>{{ cols[row].group3[col - 1] }}</strong>
            </td>
          </tr>
          <!-- Total each column -->
          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 12" :key="col" class="row-data">
              <strong>{{ totalRows[2][col] | blank }}</strong>
            </td>
            <td v-for="col in 4" :key="'g3-' + col" class="row-data">
              <strong>{{ cols[ageHig.length - 1].group3[col - 1] }}</strong>
            </td>       
          </tr>
        </tbody>
      </table>
    </div>
    <div><br /></div>
    
    <!-- Total by each strams and upper all -->
    <div>
      <table
        style="height: 87px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">អាយុ<p>(ឆ្នាំ)</p></td>
            <td class="row-header-title" colspan="4">សរុបសិស្សថ្នាក់វិទ្យាសាស្រ្ត</td>
            <td class="row-header-title" colspan="4">សរុបសិស្សថ្នាក់វិទ្យាសាស្រ្តសង្គម</td>
            <td class="row-header-title" colspan="4">សរុបសិស្សថ្នាក់វិជ្ជាជីវៈ</td>
            <td class="row-header-title" colspan="4">សរុបសិស្សមធ្យមសិក្សាទុតិយភូមិ</td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>

          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>            
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>            
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>            
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>            
            <td class="row-data">ស្រី</td>
          </tr>
          <!--Total by each streams -->
          <tr v-for="(row, r) in totalGroups" :key="'row-' + r">
            <td class="col-title">{{ ageHig[r] }}</td>
            <td v-for="(value, col) in row" :key="'cell-' + r + '-' + col" class="row-data">
              <strong>{{ value | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col1[r] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col2[r] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col3[r] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col4[r] }}</strong>
            </td>
          </tr>
          <!-- Data row for upper class/student old code -->
          <!-- 
          <tr v-for="(value, row) in ageHig.length - 1" :key="row">            
            <td class="col-title">{{ ageHig[row] }}</td>                        
            <td class="row-data">
              <strong>{{ col1[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col2[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col3[row] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ col4[row] }}</strong>
            </td>
          </tr>          
          <tr>
            <td class="col-title">សរុប</td>            
            <td class="row-data">
              <strong>{{ tCol1 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol2 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol3 | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ tCol4 | blank }}</strong>
            </td>
          </tr>
          -->
        </tbody>
      </table>
    </div>

  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { ageHigh, stuuppOnOff } from "@/utils/ascf/secConfig.js";
export default {
  props: ["data", "curacc", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      ageHig: ageHigh,
      uppOnOff: stuuppOnOff,
    };
  },
  // Compute function for student sec
  computed: {
    // new better compute the sumup by 3 group
    cols() {
      const sumByColumn = (arr) => {
        const result = [0, 0, 0, 0];

        arr.forEach((value, i) => {
          result[i % 4] += Number(value || 0);
        });

        return result;
      };

      return this.data.map(row => ({
        group1: sumByColumn(row.dt.slice(0, 8)),
        group2: sumByColumn(row.dt.slice(8, 20)),
        group3: sumByColumn(row.dt.slice(20, 32))
      }));
    },
    // new better compute the last row
    totalRows() {
      const d = this.data;
      const lastRow = d.length - 1;

      return [
        [0, 8],
        [8, 20],
        [20, 32]
      ].map(([start, end]) => {

        const result = [];

        for (let row = 0; row < lastRow; row++) {
          d[row].dt.slice(start, end).forEach((value, i) => {
            result[i] = (result[i] || 0) + Number(value || 0);
          });
        }

        result.forEach((value, i) => {
          d[lastRow].dt[start + i] = value;
        });

        return result;
      });
    },

    /* total/gender */
    col1: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col3: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 2) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col4: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 3) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    /* tCol1, tCol2, tcol3 and tcol4 are the total of total row and column */
    tCol1: function () {
      return (
        this.totalRow[0] +
        this.totalRow[4] +
        this.totalRow[8] +
        this.totalRow[12] +
        this.totalRow[16] +
        this.totalRow[20] +
        this.totalRow[24] +
        this.totalRow[28]
      );
    },
    tCol2: function () {
      return (
        this.totalRow[1] +
        this.totalRow[5] +
        this.totalRow[9] +
        this.totalRow[13] +
        this.totalRow[17] +
        this.totalRow[21] +
        this.totalRow[25] +
        this.totalRow[29]
      );
    },
    tCol3: function () {
      return (
        this.totalRow[2] +
        this.totalRow[6] +
        this.totalRow[10] +
        this.totalRow[14] +
        this.totalRow[18] +
        this.totalRow[22] +
        this.totalRow[26] +
        this.totalRow[30]
      );
    },
    tCol4: function () {
      return (
        this.totalRow[3] +
        this.totalRow[7] +
        this.totalRow[11] +
        this.totalRow[15] +
        this.totalRow[19] +
        this.totalRow[23] +
        this.totalRow[27] +
        this.totalRow[31]
      );
    },
    /* function to calculate by each 3 streams */
    totalGroups() {
      const groups = [
        [
          [8, 12],
          [20, 24]
        ],
        [
          [12, 16],
          [24, 28]
        ],
        [
          [4, 8],
          [16, 20],
          [28, 32]
        ]
      ];

      return this.data.map(row => {
        return groups.flatMap(group => {
          const result = [0, 0, 0, 0];

          group.forEach(([start, end]) => {
            row.dt.slice(start, end).forEach((value, i) => {
              result[i] += Number(value || 0);
            });
          });

          return result;
        });
      });
    }
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "0";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header-title {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.col-title {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>